function PaymentAdvance(method, view, person_id, payment_advance_id) {
    this.method = method;
    this.url = '/people/' + person_id + '/payment_advances/';

    if (payment_advance_id !== undefined) {
        this.url += payment_advance_id;
    }
    if (view === 'person') {
        this.datatable = $('#payment-advances-datatable').dataTable();
    }
    this.edit_modal = $('#generic-edit-modal');
}

PaymentAdvance.prototype.ajax_call = function(params) {
    var self = this;
    var data;
    if (params !== undefined) data = params;
    $.ajax({
        url         : self.url,
        type        : self.method,
        dataType    : 'json',
        data        : data,
        success     : function(data) {
            if (data.notice) {
                showNotification(data.notice);
                if (self.method !== 'DELETE') self.edit_modal.modal('hide');
                self.datatable.fnDraw(false);
            } else if (data.error) {
                showNotification(data.error, 'danger');
                if (self.method !== 'DELETE') $('#submit').prop('disabled',false);
            }
        },
        error : function (request, status, error) {
            showNotification(request.responseText, 'danger', 'Error in ajax call!');
        }
    });
};

global.load_payment_advance_edit_form = function (element, event, redirect_code, header) {
    event.preventDefault();
    var target_url = $(element).attr('href');
    if (target_url.length) {
        $('#generic-edit-modal .modal-header h3').text(header);
        $('#generic-edit-modal').modal('show');
        $.ajax({
            url         : target_url,
            data        : {
                redirect_to_view : redirect_code
            },
            success     : function(data) {
                if (data.length) {
                    $('#generic-edit-modal .modal-container').html(data);
                    initDatePickerElements();
                }
            }
        });
    }
}

window.delete_payment_advance = function(params) {
    if (params.length == 2) {
        var person_id = params[0];
        var payment_advance_id = params[1];
        var payment_advance = new PaymentAdvance('DELETE', 'person', person_id, payment_advance_id);
        payment_advance.ajax_call();
    }
}

$(document).on('submit', '.payment_advance_form', function(event) {
    event.preventDefault();
    var _this = $(this);
    var view = _this.data('view');
    var person_id = _this.data('person-id');
    var payment_advance_id = _this.data('id');
    var ajax_method = 'POST';
    if (payment_advance_id !== undefined) ajax_method = 'PUT';

    var payment_advance = new PaymentAdvance(ajax_method, view, person_id, payment_advance_id);
    payment_advance.ajax_call(_this.serialize());
});
